import FeeScheduleCategory, {
  FeeScheduleCategoryMaskedCurrency
} from "work/values/fee-schedule-category/fee-schedule-category";

export default class FeeSchedule {
  name?: string;
  categories: FeeScheduleCategory[] | FeeScheduleCategoryMaskedCurrency[] = [];

  constructor(categories: FeeScheduleCategory[] | FeeScheduleCategoryMaskedCurrency[], name?: string) {
    this.name = name;
    this.categories = categories;
  }
}
